import React from 'react';
import '../../static/css/main.css';
import styles from '../../static/css/pages.module.css';
import ieSvg from "../../components/icons/ieSvg";

class ServerException extends React.Component {

  componentDidMount() {
    ieSvg();
    let preloader = document.getElementById("preloader");
    preloader.style.display = "none";
  }

  render() {
    return (
      <div className={styles.pubpage}>
        <div className={styles.logo} id="app-logo"></div>
        <div className={styles.exception}></div>
        <div className="l-align_center">
          <div className={styles.title_page}>
            Что-то пошло не так
          </div>
          Сервис временно недоступен, повторите операцию позже.
          <div>
            <a href={process.env.REACT_APP_ELF_URL}>Вернуться в Интернет-банк</a>
          </div>
        </div>
      </div>
    )
  }
}

export default ServerException;